export const DEFAULT_SORTING_KEY = 'Default';
